import { useCallback } from 'react';

import { useToastStore, type ToastVariant } from '@/stores/toast.store';

/**
 * Hook canonico para emitir toasts. Atalho sobre `useToastStore.show()`.
 *
 * Mora em arquivo separado de `toast.tsx` para nao quebrar React Fast Refresh
 * (regra `react-refresh/only-export-components`: arquivos que exportam
 * componentes nao podem exportar tambem hooks/funcoes).
 *
 * `toast` e memoizado (`useCallback`) e `show` do store e estavel — assim a
 * identidade de `toast` NAO muda entre renders. Isso e critico: efeitos que
 * tem `toast` na dependency array (ex: conclusao de importacao) re-disparavam
 * a cada render quando `toast` era recriado, causando spam de toast e
 * tempestade de refetch/invalidacao (ver import-wizard-screen).
 */
export function useToast() {
  const show = useToastStore((s) => s.show);
  const toast = useCallback(
    (message: string, variant: ToastVariant = 'default', duration = 4000) =>
      show(message, { variant, duration }),
    [show],
  );
  return { toast };
}
